module.exports = __webpack_public_path__ + "img/lv_success_6.dfa2f3d1.png";